import icons from './icons'

import './assets/css/style.css'
import './assets/scss/_global.scss'
import './assets/scss/_typography.scss'
import 'cropperjs/dist/cropper.css'
import 'flag-icons/css/flag-icons.css'

import * as atoms from './components/atoms'
import * as molecules from './components/molecules'
import * as organisms from './components/organisms'
import * as templates from './components/templates'

import {
  changeTheme,
  changeRadius,
  DefaultTheme,
  DesignSystemColors,
} from './theme'

export {changeTheme, changeRadius, DesignSystemColors} from './theme'

export const Theme = {
  light: true,
  themes: {
    light: {
      theme: DefaultTheme(),
    },
  },
}

export const ZooxIcons = icons.reduce((zooxIcons, icon) => {
  return Object.assign(zooxIcons, {[icon]: 'zi-' + icon})
}, {})

const ZooxDesignSystem = {
  install(Vue) {
    const components = Object.assign({}, atoms, molecules, organisms, templates)

    Object.keys(components).map((key) => {
      const component = components[key]

      if (!component.name) {
        // eslint-disable-next-line
        console.error('sem nome', key)
      }
      try {
        Vue.component(component.name, component)
      } catch (e) {
        // eslint-disable-next-line
        console.error('Componente não instalado', key)
      }
    })

    Vue.prototype.$zoox = {
      colors: DesignSystemColors,
    }
    Vue.set(Vue.prototype.$zoox, 'cardShadow', false)
  },
}

if (typeof window !== 'undefined') {
  window.ZooxIcons = ZooxIcons
  window.ZooxDesignSystem = ZooxDesignSystem
  window.ZooxTheme = Theme
  window.DesignSystem = {changeTheme, changeRadius}
}

export default ZooxDesignSystem
